import React, { useCallback } from 'react';
import FilterToggleGroup, { FilterToggleRow } from '../common/list/FilterToggleGroup';

const invTyps = [
  { id: 1, value: '매출', label: '채권', color: 'primary' },
  { id: 2, value: '매입', label: '채무', color: 'secondary' },
];

// 전체/완료/예정 (BITO_0425 p43, 0515 p54 "탭 전체ㅣ수금(지급)완료ㅣ수금(지급)예정", 2026-10-20).
// 코드 값(searchYn='Y'/'N')은 그대로 두고 라벨만 슬라이드에 맞춘다.
const useYns = [
  { id: 0, value: '', label: '전체', color: null },
  { id: 1, value: 'Y', label: '완료', color: 'success' },
  { id: 2, value: 'N', label: '예정', color: 'error' },
];

// 구분/상태 필터 - chancemng 설계(공통 FilterToggleGroup) 적용(2026-10-22).
const BondsDeptsStatusList = ({ filters, onFilters }) => {
  const handleFilterBillType = useCallback((value) => onFilters('searchInvTyp', value), [onFilters]);
  const handleFilterStatus = useCallback((value) => onFilters('searchYn', value), [onFilters]);

  return (
    <FilterToggleRow>
      <FilterToggleGroup label="구분" options={invTyps} value={filters?.searchInvTyp} onChange={handleFilterBillType} />
      <FilterToggleGroup label="상태" options={useYns} value={filters?.searchYn} onChange={handleFilterStatus} />
    </FilterToggleRow>
  );
};

export default BondsDeptsStatusList;
